// extracted by mini-css-extract-plugin
module.exports = {"mainWrapper":"service-center_mainWrapper__tLn83","contentWrapper":"service-center_contentWrapper__FDGg6"};